<i class="{{icon}}" (click)="onClick($event)" [ngClass]="{'faded': disabled, 'active': !disabled}"></i>
